import React, { useMemo, useRef } from "react";

import { IonButton, IonButtons, IonIcon, IonImg, IonTitle, IonToolbar } from "@ionic/react";

// import components
// import TS interface
import { IToolbarProps } from "../types";

// import styles
import classNames from "classnames/bind";
import styles from "./ToolbarMobile.module.scss";
import { call, heart, shareSocial } from "ionicons/icons";
import { useConfig } from "../../../providers/config";
import Images from "@core/images";
import BackButton from "../../BackButton/BackButton";
import { SelectShippingZone } from "../../SelectShippingZone/SelectShippingZone";
import { shareApp } from "../../../utils/shareApp";
import ExpressMarketSwitcher from "../../ExpressMarketSwitcher/ExpressMarketSwitcher";
import { CurrentShippingAddress } from "../../CurrentShippingAddress/CurrentShippingAddress";
import { CustomerAddressSelectProvider } from "../../../providers/CustomerAddresses/CustomerAddressesStateContext";

const cx = classNames.bind(styles);

export interface IToolbarMobileProps extends IToolbarProps {}

const ToolbarMobile = ({ showBackButton, showSearchButton, showShippingZone }: IToolbarMobileProps) => {
  const config = useConfig();
  const shareButton = useRef<HTMLIonButtonElement>(null);

  const isDefaultShippingZoneEnabled = useMemo(() => {
    return config?.shipping.isShippingZonesEnabled && config?.shipping.showDefaultShippingZone;
  }, [config?.shipping.isShippingZonesEnabled, config?.shipping.showDefaultShippingZone]);

  return (
    <CustomerAddressSelectProvider>
      <div>
        {config?.isExpressDeliveryEnabled && (
          <div className={cx("change-mode-toolbar", "flex items-center justify-center !rounded-none !bg-[#282828]")}>
            {showBackButton && <BackButton buttonStyles={cx("expressToolbarBackButton")} />}
            <ExpressMarketSwitcher wrapperClassname={cx(showBackButton && "mx-auto pr-6")} />
          </div>
        )}
        <IonToolbar
          className={cx(
            "toolbar",
            !config?.isExpressDeliveryEnabled && "ion-hide-md-up",
            config?.isExpressDeliveryEnabled &&
              "flex !items-center justify-center !rounded-none border-1 border-solid border-[#DDDDDD] !bg-[#fff] h-[58px]"
          )}
        >
          <IonButtons slot="start">
            {!config?.isExpressDeliveryEnabled && showShippingZone && isDefaultShippingZoneEnabled && (
              <SelectShippingZone />
            )}
            {!config?.isExpressDeliveryEnabled && showBackButton && <BackButton />}
            {config?.isExpressDeliveryEnabled && config?.shipping.showCurrentShippingAddressSelect && (
              <div className={cx("currentAddress__margins")}>
                <CurrentShippingAddress />
              </div>
            )}
            {!config?.isExpressDeliveryEnabled && (
              <IonTitle>
                <IonImg className={cx("title-img")} src={Images.roundLogo} />
              </IonTitle>
            )}
          </IonButtons>
          {!config?.isExpressDeliveryEnabled && (
            <IonTitle>
              <IonImg className={cx("logo-centered", "title-img")} src={Images.roundLogo} />
            </IonTitle>
          )}
          {!config?.isExpressDeliveryEnabled && (config?.wishListIcons || !showSearchButton) && (
            <IonButtons slot="end" className={cx("testclass")}>
              <IonButton
                fill="clear"
                className={cx(isDefaultShippingZoneEnabled ? "button-sm" : "button")}
                routerLink="/wish-list"
                routerDirection="forward"
              >
                <IonIcon className={cx("icon")} icon={heart} />
              </IonButton>
              <IonButton
                fill="clear"
                className={cx(isDefaultShippingZoneEnabled ? "button-sm" : "button")}
                routerLink="/contact-us"
                routerDirection="forward"
              >
                <IonIcon className={cx("icon")} icon={call} />
              </IonButton>
              <IonButton
                fill="clear"
                className={cx(isDefaultShippingZoneEnabled ? "button-sm" : "button")}
                routerDirection="forward"
                onClick={() => shareApp({ appSettings: config })}
                ref={shareButton}
              >
                <IonIcon className={cx("icon", "icon-inf")} icon={shareSocial} />
              </IonButton>
            </IonButtons>
          )}
        </IonToolbar>
      </div>
    </CustomerAddressSelectProvider>
  );
};

export default ToolbarMobile;
